export const HERO = 'hero'
export const EXPERIENCE = 'experience'
export const PROJECTS = 'projects'
export const SKILLS = 'skills'
export const CONTACT = 'contact'
